import { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, memo, forwardRef } from 'react';

type PlayerCanvasProps = {
  visible: boolean;
  loading: boolean;
};

export const PlayerCanvas: ForwardRefExoticComponent<
  PropsWithoutRef<PlayerCanvasProps> & RefAttributes<HTMLDivElement>
> = memo(
  forwardRef(({ visible, loading }, ref) => (
    <div
      sx={{ visibility: visible ? 'visible' : 'hidden', opacity: loading ? 0.5 : 1 }}
      ref={ref}
    />
  ))
);
